import MarginLabel from "./MarginLabel";
import {ReactNode} from "react";

interface Props
{
    paragraphNo: number
    children?: ReactNode
}
export default function Paragraph({ paragraphNo, children }: Props)
{
    return <div id={`paragraph-${paragraphNo}`} >
        <MarginLabel text={`Pr ${paragraphNo}`} />
        {children}
    </div>
}
